import { firebaseDatabase } from '../../firebaseDb';

export default {

    state : {
        name : 'api from firebase',
        my_tools_api_err_status: false,
        my_tools_api_pending_status: true,
        langs : []

    },

    getters:{

        getMyToolsApiErrStatus(state){
          return state.my_tools_api_err_status;
        },
        getMyToolsApiPendingStatus(state){
            return state.my_tools_api_pending_status;
        },
        getLangs(state){
            return state.langs
        }

    },

    actions:{

         initMyToolsApi({commit,state}){
             // get data from firebase mytools collection
             firebaseDatabase
                 .collection('mytools')
                 .onSnapshot((snapshotChange) => {
                     let langs = [];
                     snapshotChange.forEach((doc) => {
                         langs.push({
                             key: doc.id,
                             lang : doc.data().langs,
                             priority : doc.data().priority,
                         });
                     });
                     commit('INIT_MY_Tools_API',langs);
                     // check error status and pending status
                     langs.length < 1 ?
                         state.my_tools_api_err_status = true :
                         state.my_tools_api_pending_status = false
                 });
        }
    },

    mutations:{

        INIT_MY_Tools_API(state,payload){
            state.langs = payload;
        }

    }

}